var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"memberShare"},[_c('img',{staticClass:"imgs",attrs:{"src":require("@/assets/img/mine/share.png")}})])
}]

export { render, staticRenderFns }